import { IPOOTPREGISTER_DATA, IPOOTPREGISTER_ERROR_DATA, IPOOTPREGISTER_HIDE_ERROR_DATA, IPOOTPREGISTER_START_LOADER, IPOOTPREGISTER_STOP_LOADER, } from "../interface/IpoOtpRegister";
import store from "@frameworks/web/redux/store";
class IpoOtpRegisterActiton {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getIpoOtpRegister(IpoOtpRegister) {
        this.dispatch({
            type: IPOOTPREGISTER_DATA,
            payload: { IpoOtpRegister },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: IPOOTPREGISTER_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: IPOOTPREGISTER_HIDE_ERROR_DATA,
        });
    }
    startLoader() {
        this.dispatch({
            type: IPOOTPREGISTER_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: IPOOTPREGISTER_STOP_LOADER,
        });
    }
}
export default IpoOtpRegisterActiton;
